export const partnerCode = {
    baokim: "baokim",
    momo:"momo",
    localCard:"MBECOM",
    internationalCard:"UNLIMINT",
    qrGen:'QRGEN',
    vietQr:'VIETQR'
}
